import React, { FunctionComponent } from "react"
import { Skeleton } from "@walmart-web/livingdesign-components"
import { useIntl } from "react-intl"
import "./index.scss"
import { concatClassNames } from "helpers/jsxHelpers"

interface ChartMessageRecord {
	id: string
	values?: Record<string, any>
}

interface ChartContainerProps {
	title: ChartMessageRecord
	body?: ChartMessageRecord
	buttons?: React.ReactNode
	children?: React.ReactNode
	isLoading?: boolean
	className?: string
}

const ChartContainer: FunctionComponent<ChartContainerProps> = ({
	title,
	body,
	children,
	isLoading,
	buttons,
	className,
}) => {
	const intl = useIntl()

	return (
		<div
			className={concatClassNames(["main-chart-container", className])}
			data-testid="main-chart-container"
		>
			{isLoading ? (
				<React.Fragment>
					<Skeleton role="progressbar" UNSAFE_className="title-skeleton" />
					<Skeleton role="progressbar" />
					<Skeleton role="progressbar" UNSAFE_className="chart-skeleton" />
				</React.Fragment>
			) : (
				<React.Fragment>
					<div className={concatClassNames(["chart-header", className])}>
						<div className="chart-title font-24 bold">
							{intl.formatMessage({ id: title.id }, title.values)}
						</div>
						{buttons}
					</div>
					{body && (
						<div className="chart-subtitle">
							{intl.formatMessage({ id: body.id }, body.values)}
						</div>
					)}
					{children}
				</React.Fragment>
			)}
		</div>
	)
}

export default ChartContainer
